<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <form-base
          :submit-status="submitStatus"
          action="Create"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
        >
          <template v-slot:fields>
            <form-group label="Stakeholder" :required="true">
              <v-select
                @blur="$v.engagement.stakeholder_id.$touch"
                :class="{ 'is-invalid': $v.engagement.stakeholder_id.$error }"
                v-model="engagement.stakeholder_id"
                :options="stakeholders"
                label="name"
                :reduce="(stakeholder) => stakeholder.id"
              >
                <template slot="option" slot-scope="dt">
                  <div>
                    {{ dt.name }}
                    <br />
                    {{ dt.contact_person }} - {{ dt.physical_address }}
                  </div>
                </template>
                <template slot="selected-option" slot-scope="dt">
                  {{ dt.name }}
                </template>
              </v-select>

              <div
                class="invalid-feedback"
                v-if="!$v.engagement.stakeholder_id.required"
              >
                Please select stakeholder
              </div>
            </form-group>

            <form-group label="Mode" :required="true">
              <b-form-select
                @blur="$v.engagement.mode.$touch"
                :class="{ 'is-invalid': $v.engagement.mode.$error }"
                v-model="engagement.mode"
                :options="modes"
              />
              <div class="invalid-feedback" v-if="!$v.engagement.mode.required">
                Please select mode
              </div>
            </form-group>

            <form-group label="Engagement Date" :required="true">
              <b-form-datepicker
                id="example-datepicker"
                v-model="engagement.date"
                class="mb-2"
              ></b-form-datepicker>

              <div class="invalid-feedback" v-if="!$v.engagement.date.required">
                Please select date
              </div>
            </form-group>

            <form-group label="Engagement Time" :required="true">
              <b-form-timepicker
                v-model="engagement.time"
                locale="en"
              ></b-form-timepicker>

              <div class="invalid-feedback" v-if="!$v.engagement.time.required">
                Please select time
              </div>
            </form-group>

            <form-group label="Checking In">
              <b-form-checkbox
                v-model="engagement.checking_in"
                name="check-button"
                switch
                size="lg"
              >
              </b-form-checkbox>
            </form-group>

            <form-group label="Note">
              <textarea-autosize
                class="form-control"
                v-model="engagement.note"
              />
            </form-group>
          </template>
        </form-base>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import engagementRepo from "@/api/repos/engagementRepo";
import { required } from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";

export default {
  components: {
    formBase,
    formGroup,
  },

  validations: {
    engagement: {
      mode: {
        required,
      },
      date: {
        required,
      },
      time: {
        required,
      },
      stakeholder_id: {
        required,
      },
    },
  },

  mounted() {
    this.getData();
  },

  data() {
    return {
      engagement: {
        checking_in: true,
        date: this.moment(new Date()).format("YYYY-MM-DD"),
        time: this.moment(new Date()).format("HH:mm"),
      },
      stakeholders: [],
      modes: [],
      loading: false,
      errors: null,
      submitStatus: null,
    };
  },

  methods: {
    async getData() {
      try {
        let { data } = await engagementRepo.createGetData(true);
        this.stakeholders = data.stakeholders;
        this.modes = data.modes;
      } catch (error) {
        console.log(error);
      }
    },

    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        this.submitStatus = null;
      } else {
        try {
          this.engagement.engagement_date =
            this.engagement.date + " " + this.engagement.time;
          let {data} = await engagementRepo.create(this.engagement);
          this.engagement.id = data.engagement.id;

          if (this.engagement.checking_in) {
            this.checkIn();
          } else {
              this.loading = false;
          this.submitStatus = null;
            this.$emit("engagementCreated");

          }
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            console.log(this.errors);
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
            this.loading = false;
          this.submitStatus = null;
        } 
      }
    },
    async checkIn() {
      this.loading = true;
      let lat = null;
      let lng = null;
      let err = null;

      await this.getLocation().then(
        (location) => {
          lat = location.coords.latitude;
          lng = location.coords.longitude;
        },
        (error) => {
          err = "Browser Error: " + error.message;
        }
      );

      try {
        await engagementRepo.checkIn(this.engagement.id, {
          latitude: lat,
          longitude: lng,
          error: err,
        });
        this.$emit("engagementUpdated");
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async getLocation() {
      return new Promise((resolve, reject) => {
        if (!("geolocation" in navigator)) {
          this.$router.push({ path: "no-location" });
        }

        navigator.geolocation.getCurrentPosition(
          (pos) => {
            resolve(pos);
          },
          (err) => {
            reject(err);
          },
          {
            timeout: 10 * 1000,
          }
        );
      });
    },
  },
};
</script>

